import moment from 'moment';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { useHistory, useParams } from 'react-router';
import React, { useCallback, useEffect, useRef, useState } from 'react';

import {
  Button,
  Divider,
  FormControl,
  FormLabel,
  Grid,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core';

import Input from '../../../components/Input';
import CustomCheckbox from '../../../components/Checkbox';
import { useAxios } from '../../../utils/hooks';
import { Form as FormModel } from '../../../models/form';
import Snackbar, { AlertComponentProps } from '../../../components/Snackbar';
import Loader from '../../../components/Loader';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    background: 'white',
    padding: theme.spacing(3),
    margin: theme.spacing(3),
    marginBottom: theme.spacing(10),
  },
  formTitles: {
    fontWeight: 'bolder',
  },
  formControl: {
    margin: theme.spacing(2, 0),
  },
  divider: {
    margin: theme.spacing(2),
  },
}));

const InitForm: React.FC = () => {
  const api = useAxios();
  const classes = useStyles();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState<FormModel | null>(null);
  const { formId } = useParams<{ id: string; formId: string }>();

  const formRef = useRef<FormHandles>(null);

  const [alert, setAlert] = useState<
    AlertComponentProps & { isActive: boolean }
  >({
    isActive: false,
    type: 'info',
    message: 'none',
  });

  useEffect(() => {
    async function getInitFormData() {
      try {
        const formResponse = await api.current?.get(`/forms/${formId}`);

        setForm(formResponse?.data);
      } catch (error) {
        setAlert({
          isActive: true,
          type: 'error',
          message: 'Erro ao carregar formulário.',
        });
      } finally {
        setLoading(false);
      }
    }

    getInitFormData();
  }, [api, formId]);

  const handleSubmit = useCallback((data) => {
    console.log(data);
  }, []);

  return (
    <>
      <Loader loading={loading} />

      {!loading && (
        <Form
          id="form"
          ref={formRef}
          initialData={form?.answers}
          onSubmit={handleSubmit}
          className={classes.root}
        >
          <FormControl fullWidth className={classes.formControl}>
            <Typography
              variant="h5"
              component="h1"
              align="center"
              className={classes.formTitles}
            >
              Ficha de Contato Inicial
            </Typography>

            <Typography
              variant="h5"
              component="h1"
              align="center"
              className={classes.formTitles}
            >
              Atendimento a Pais e/ou Responsáveis
            </Typography>

            <Typography
              variant="h6"
              component="h6"
              align="center"
              className={classes.formTitles}
            >
              (preenchida pelo paciente ou responsável)
            </Typography>

            <Divider className={classes.divider} />
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <FormLabel className={classes.formTitles}>
              DADOS DE IDENTIFICAÇÃO
            </FormLabel>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  1 - DOS INTERESSADOS PELO ATENDIMENTO:
                </FormLabel>
              </Grid>

              <Grid item xs={12}>
                <Input
                  id="interested_name"
                  label="Nome (1)"
                  disabled
                  name="interested_name"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  id="interested_rg"
                  label="RG"
                  disabled
                  name="interested_rg"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  id="interested_cpf"
                  label="CPF"
                  disabled
                  name="interested_cpf"
                />
              </Grid>

              <Grid item xs={4}>
                <Input
                  id="interested_gender"
                  label="Gênero"
                  disabled
                  name="interested_gender"
                />
              </Grid>

              <Grid item xs={4}>
                <Input
                  id="interested_race"
                  label="Raça/cor"
                  disabled
                  name="interested_race"
                />
              </Grid>

              <Grid item xs={4}>
                <Input
                  id="interested_birth"
                  label="Data de Nascimento"
                  placeholder="23/02/1997"
                  disabled
                  name="interested_birth"
                />
              </Grid>

              <Grid item xs={2}>
                <Input
                  id="interested_age"
                  label="Idade"
                  disabled
                  name="interested_age"
                />
              </Grid>

              <Grid item xs={5}>
                <Input
                  id="interested_birth_local"
                  label="Naturalidade"
                  disabled
                  name="interested_birth_local"
                />
              </Grid>

              <Grid item xs={5}>
                <Input
                  id="religion"
                  label="Religião"
                  disabled
                  name="religion"
                />
              </Grid>

              <FormControl fullWidth className={classes.formControl}>
                <Divider className={classes.divider} />
              </FormControl>

              <Grid item xs={12}>
                <Input
                  id="interested_2_name"
                  label="Nome (2)"
                  disabled
                  name="interested_2_name"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  id="interested_2_rg"
                  label="RG"
                  disabled
                  name="interested_2_rg"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  id="interested_2_cpf"
                  label="CPF"
                  disabled
                  name="interested_2_cpf"
                />
              </Grid>

              <Grid item xs={4}>
                <Input
                  id="interested_2_gender"
                  label="Gênero"
                  disabled
                  name="interested_2_gender"
                />
              </Grid>

              <Grid item xs={4}>
                <Input
                  id="interested_2_race"
                  label="Raça/cor"
                  disabled
                  name="interested_2_race"
                />
              </Grid>

              <Grid item xs={4}>
                <Input
                  id="interested_2_birth"
                  label="Data de Nascimento"
                  placeholder="23/02/1997"
                  disabled
                  name="interested_2_birth"
                />
              </Grid>

              <Grid item xs={2}>
                <Input
                  id="interested_2_age"
                  label="Idade"
                  disabled
                  name="interested_2_age"
                />
              </Grid>

              <Grid item xs={5}>
                <Input
                  id="interested_2_birth_local"
                  label="Naturalidade"
                  disabled
                  name="interested_2_birth_local"
                />
              </Grid>

              <Grid item xs={5}>
                <Input
                  id="religion_2"
                  label="Religião"
                  disabled
                  name="religion_2"
                />
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  2 - DOS FILHOS:
                </FormLabel>
              </Grid>

              <Grid item xs={8}>
                <Input
                  id="child_1_name"
                  label="Nome"
                  disabled
                  name="child_1_name"
                />
              </Grid>

              <Grid item xs={4}>
                <Input
                  id="child_1_age"
                  label="Idade"
                  disabled
                  name="child_1_age"
                />
              </Grid>

              <Grid item xs={8}>
                <Input
                  id="child_2_name"
                  label="Nome"
                  disabled
                  name="child_2_name"
                />
              </Grid>

              <Grid item xs={4}>
                <Input
                  id="child_2_age"
                  label="Idade"
                  disabled
                  name="child_2_age"
                />
              </Grid>

              <Grid item xs={8}>
                <Input
                  id="child_3_name"
                  label="Nome"
                  disabled
                  name="child_3_name"
                />
              </Grid>

              <Grid item xs={4}>
                <Input
                  id="child_3_age"
                  label="Idade"
                  disabled
                  name="child_3_age"
                />
              </Grid>

              <Grid item xs={8}>
                <Input
                  id="child_4_name"
                  label="Nome"
                  disabled
                  name="child_4_name"
                />
              </Grid>

              <Grid item xs={4}>
                <Input
                  id="child_4_age"
                  label="Idade"
                  disabled
                  name="child_4_age"
                />
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Divider className={classes.divider} />
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>ENDEREÇO:</FormLabel>
              </Grid>

              <Grid item xs={12}>
                <Input
                  id="address_street"
                  label="Logradouro"
                  disabled
                  name="address_street"
                  placeholder="Rua/Av./Denominação/número/complemento"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  id="address_neighborhood"
                  label="Bairro"
                  disabled
                  name="address_neighborhood"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  id="address_city"
                  label="Cidade"
                  disabled
                  name="address_city"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  id="address_zipcode"
                  label="CEP"
                  disabled
                  name="address_zipcode"
                />
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Divider className={classes.divider} />
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>TELEFONES:</FormLabel>
              </Grid>

              <Grid item xs={6}>
                <Input
                  id="residencial_phone"
                  label="Residencial"
                  disabled
                  name="residencial_phone"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  id="comercial_phone"
                  label="Comercial"
                  disabled
                  name="comercial_phone"
                />
              </Grid>

              <Grid item xs={6}>
                <Input id="phone" label="Celular" disabled name="phone" />
              </Grid>

              <Grid item xs={6} />

              <Grid item xs={6}>
                <Input
                  id="note_phone"
                  label="Para recados"
                  disabled
                  name="note_phone"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  id="note_phone_who"
                  label="Com quem?"
                  disabled
                  name="note_phone_who"
                />
              </Grid>

              <Grid item xs={12}>
                <Input id="email" label="E-mail" disabled name="email" />
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Divider className={classes.divider} />
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  Como soube do CEAPIA?
                </FormLabel>
              </Grid>

              <Grid item xs={3}>
                <CustomCheckbox
                  disabled
                  name="know_school"
                  value="know_school"
                  label="Escola"
                />
              </Grid>
              <Grid item xs={9}>
                <Input
                  id="know_school_desc"
                  label="Qual?"
                  disabled
                  name="know_school_desc"
                />
              </Grid>

              <Grid item xs={3}>
                <CustomCheckbox
                  disabled
                  name="know_event"
                  value="know_event"
                  label="Evento realizado no CEAPIA"
                />
              </Grid>
              <Grid item xs={9}>
                <Input
                  id="know_event_desc"
                  label="Qual?"
                  disabled
                  name="know_event_desc"
                />
              </Grid>

              <Grid item xs={3}>
                <CustomCheckbox
                  disabled
                  name="know_social_media"
                  value="know_social_media"
                  label="Facebook / Instagram / Site"
                />
              </Grid>
              <Grid item xs={9}>
                <Input
                  id="know_social_media_desc"
                  label="Qual?"
                  disabled
                  name="know_social_media_desc"
                />
              </Grid>

              <Grid item xs={3}>
                <CustomCheckbox
                  disabled
                  name="know_treatment"
                  value="know_treatment"
                  label="Já se tratou ou teve familiar em tratamento no CEAPIA?"
                />
              </Grid>
              <Grid item xs={9}>
                <Input
                  id="know_treatment_desc"
                  label="Quem?"
                  disabled
                  name="know_treatment_desc"
                />
              </Grid>

              <Grid item xs={3}>
                <CustomCheckbox
                  disabled
                  name="know_family"
                  value="know_family"
                  label="Possui familiar em avaliação ou tratamento atualmente? "
                />
              </Grid>
              <Grid item xs={9}>
                <Input
                  id="know_family_desc"
                  label="Quem?"
                  disabled
                  name="know_family_desc"
                />
              </Grid>

              <Grid item xs={3}>
                <CustomCheckbox
                  disabled
                  name="know_professional"
                  value="know_professional"
                  label="Terapeuta"
                />
              </Grid>
              <Grid item xs={9}>
                <Input
                  id="know_professional_desc"
                  label="Quem?"
                  disabled
                  name="know_professional_desc"
                />
              </Grid>

              <Grid item xs={3}>
                <CustomCheckbox
                  disabled
                  name="know_indication"
                  value="know_indication"
                  label="Teve indicação de alguém?"
                />
              </Grid>
              <Grid item xs={9}>
                <Input
                  id="know_indication_desc"
                  label="Quem?"
                  disabled
                  name="know_indication_desc"
                />
              </Grid>

              <Grid item xs={3}>
                <CustomCheckbox
                  disabled
                  name="know_others"
                  value="know_others"
                  label="Outros"
                />
              </Grid>
              <Grid item xs={9}>
                <Input
                  id="know_others_desc"
                  label="Outros"
                  disabled
                  name="know_others_desc"
                />
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Divider className={classes.divider} />
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  MOTIVO DA PROCURA AO CEAPIA:
                </FormLabel>
              </Grid>

              <Grid item xs={12}>
                <Input
                  id="motive"
                  label="Descreva resumidamente qual é e quando começou o problema que o traz ao CEAPIA"
                  disabled
                  name="motive"
                  isMultiline
                  rows={5}
                />
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Divider className={classes.divider} />
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  NÍVEL SÓCIO-ECONÔMICO:
                </FormLabel>
              </Grid>

              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  Interessado (1):
                </FormLabel>
              </Grid>

              <Grid item xs={12}>
                <Input
                  id="interested_1_job"
                  label="Profissão"
                  disabled
                  name="interested_1_job"
                />
              </Grid>

              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>Instrução:</FormLabel>
              </Grid>

              <Grid item xs={4}>
                <CustomCheckbox
                  disabled
                  name="interested_1_school_1"
                  value="interested_1_school_1"
                  label="3°Grau"
                />
              </Grid>

              <Grid item xs={8}>
                <Input
                  id="interested_1_school_1_desc"
                  label="Curso"
                  disabled
                  name="interested_1_school_1_desc"
                />
              </Grid>

              <Grid item xs={4}>
                <CustomCheckbox
                  disabled
                  name="interested_1_school_2"
                  value="interested_1_school_2"
                  label="2°Grau"
                />
              </Grid>

              <Grid item xs={8}>
                <Input
                  id="interested_1_school_2_desc"
                  label=" "
                  disabled
                  name="interested_1_school_2_desc"
                />
              </Grid>

              <Grid item xs={4}>
                <CustomCheckbox
                  disabled
                  name="interested_1_school_3_desc"
                  value="interested_1_school_3_desc"
                  label="1°Grau"
                />
              </Grid>

              <Grid item xs={8}>
                <Input
                  id="interested_1_school_3_desc"
                  label=" "
                  disabled
                  name="interested_1_school_3_desc"
                />
              </Grid>

              <Grid item xs={12}>
                <Input
                  id="interested_1_income"
                  label="Renda"
                  placeholder="R$"
                  disabled
                  name="interested_1_income"
                />
              </Grid>

              <FormControl fullWidth className={classes.formControl}>
                <Divider className={classes.divider} />
              </FormControl>

              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  Interessado (2):
                </FormLabel>
              </Grid>

              <Grid item xs={12}>
                <Input
                  id="interested_2_job"
                  label="Profissão"
                  disabled
                  name="interested_2_job"
                />
              </Grid>

              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>Instrução:</FormLabel>
              </Grid>

              <Grid item xs={4}>
                <CustomCheckbox
                  disabled
                  name="interested_2_school_1"
                  value="interested_2_school_1"
                  label="3°Grau"
                />
              </Grid>

              <Grid item xs={8}>
                <Input
                  id="interested_2_school_1_desc"
                  label="Curso"
                  disabled
                  name="interested_2_school_1_desc"
                />
              </Grid>

              <Grid item xs={4}>
                <CustomCheckbox
                  disabled
                  name="interested_2_school_2"
                  value="interested_2_school_2"
                  label="2°Grau"
                />
              </Grid>

              <Grid item xs={8}>
                <Input
                  id="interested_2_school_2_desc"
                  label=" "
                  disabled
                  name="interested_2_school_2_desc"
                />
              </Grid>

              <Grid item xs={4}>
                <CustomCheckbox
                  disabled
                  name="interested_2_school_3_desc"
                  value="interested_2_school_3_desc"
                  label="1°Grau"
                />
              </Grid>

              <Grid item xs={8}>
                <Input
                  id="interested_2_school_3_desc"
                  label=" "
                  disabled
                  name="interested_2_school_3_desc"
                />
              </Grid>

              <Grid item xs={12}>
                <Input
                  id="interested_2_income"
                  label="Renda"
                  placeholder="R$"
                  disabled
                  name="interested_2_income"
                />
              </Grid>

              <Grid item xs={12}>
                <Input
                  id="family_income"
                  label="Renda total da família"
                  placeholder="R$"
                  disabled
                  name="family_income"
                />
              </Grid>

              <FormControl fullWidth className={classes.formControl}>
                <Divider className={classes.divider} />
              </FormControl>

              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>Moradia:</FormLabel>
              </Grid>

              <Grid item xs={3}>
                <CustomCheckbox
                  disabled
                  name="housing_own"
                  value="housing_own"
                  label="Própria"
                />
              </Grid>

              <Grid item xs={3}>
                <CustomCheckbox
                  disabled
                  name="housing_rent"
                  value="housing_rent"
                  label="Alugada"
                />
              </Grid>

              <Grid item xs={3}>
                <CustomCheckbox
                  disabled
                  name="housing_financed"
                  value="housing_financed"
                  label="Financiada"
                />
              </Grid>

              <Grid item xs={3}>
                <CustomCheckbox
                  disabled
                  name="housing_given"
                  value="housing_given"
                  label="Cedida"
                />
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Divider className={classes.divider} />
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  RELAÇÃO DE TODAS AS PESSOAS QUE RESIDEM NA CASA:
                </FormLabel>
              </Grid>

              {[1, 2, 3, 4].map((idx) => (
                <>
                  <Grid item xs={3}>
                    <Input
                      id={`family_list_name_${idx}`}
                      disabled
                      name={`family_list_name_${idx}`}
                      label="Nome"
                    />
                  </Grid>

                  <Grid item xs={3}>
                    <Input
                      id={`family_list_age_${idx}`}
                      disabled
                      name={`family_list_age_${idx}`}
                      label="Idade"
                    />
                  </Grid>

                  <Grid item xs={3}>
                    <Input
                      id={`family_list_parent_${idx}`}
                      disabled
                      name={`family_list_parent_${idx}`}
                      label="Parentesco"
                    />
                  </Grid>

                  <Grid item xs={3}>
                    <Input
                      id={`family_list_job_${idx}`}
                      label="Ocupação"
                      disabled
                      name={`family_list_job_${idx}`}
                    />
                  </Grid>
                </>
              ))}
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Divider className={classes.divider} />
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  TERMO DE AUTORIZAÇÃO:
                </FormLabel>
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                Eu
                <Input
                  id="term_responsible_name"
                  label="Nome do responsável"
                  disabled
                  name="term_responsible_name"
                />
              </Grid>

              <Grid item xs={12}>
                responsável por
                <Input
                  id="term_responsible_for"
                  label="Responsável por"
                  disabled
                  name="term_responsible_for"
                />
              </Grid>

              <Grid item xs={12}>
                <p>
                  estou ciente de que o CEAPIA é uma Instituição que visa o
                  ensino, o atendimento e a pesquisa na infância e na
                  adolescência e autorizo que os dados referentes ao atendimento
                  possam ser utilizados na Instituição para fins de pesquisa.
                </p>

                <p>
                  Outrossim, autorizo a Instituição a utilizar, sempre que
                  julgar necessário, recursos técnicos nos atendimentos, tais
                  como sala com espelho que permite visão unilateral, com
                  auxílio de grupo técnico.
                </p>

                <p>
                  O CEAPIA compromete-se a manter sob estrito sigilo
                  profissional as informações obtidas nos atendimentos.
                </p>

                <p>
                  Declaro estar ciente de que para desmarcar a triagem é
                  necessário avisar com 24 horas de antecedência, caso contrário
                  será cobrada nova consulta de triagem.
                </p>

                <p>
                  Triagem desmarcada com até 24 horas de antecedência terá 75%
                  do valor ressarcido.
                </p>

                <p>
                  Declaro ainda estar ciente de que, o valor dos atendimentos é
                  reajustado anualmente, no dia 01 de julho.
                </p>
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Divider className={classes.divider} />
          </FormControl>

          <FormControl fullWidth className={classes.formTitles}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                O NÃO COMPARECIMENTO NA TRIAGEM IMPLICARÁ NA ELIMINAÇÃO DESTES
                DOCUMENTOS.
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formTitles}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <CustomCheckbox
                  disabled
                  name="agree"
                  value="agree"
                  label="Estou ciente e concordo com as informações deste termo."
                />
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Divider className={classes.divider} />
          </FormControl>

          <FormControl fullWidth className={classes.formTitles}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                Diretora de Atendimento
              </Grid>

              <Grid item xs={6}>
                Assinatura do responsável
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formTitles}>
            <Grid container spacing={2} justify="flex-end">
              <Grid item xs={2}>
                <Input
                  id="form_data"
                  label="Data"
                  disabled
                  name="form_data"
                  defaultValue={moment().format('DD/MM/YYYY').toString()}
                />
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Divider className={classes.divider} />
          </FormControl>

          <FormControl fullWidth className={classes.formTitles}>
            <Grid container spacing={1} justify="center">
              <Grid item>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => history.goBack()}
                >
                  Voltar
                </Button>
              </Grid>
            </Grid>
          </FormControl>
        </Form>
      )}

      {alert.isActive && <Snackbar {...alert} />}
    </>
  );
};

export default InitForm;
